import { VippsConnection, Account } from '../../../types/management-auth';

export enum ActionTypes {
    OpenVippsModal = '[settings/paymentConnections/vipps] OPEN_VIPPS_MODAL',
    InitiateVippsConnection = '[settings/paymentConnections/vipps] INITIATE_VIPPS_CONNECTION',
    UpdateAccountAndInitiateVippsConnection = '[settings/paymentConnections/vipps] UPDATE_ACCOUNT_AND_INITIATE_VIPPS_CONNECTION',
    FetchInitiateVippsConnectionResponse = '[settings/paymentConnections/vipps] INITIATE_VIPPS_CONNECTION_RESPONSE',
    UpdateVippsConnection = '[settings/paymentConnections/vipps] UPDATE_VIPPS_CONNECTION',
    UpdateVippsConnectionResponse = '[settings/paymentConnections/vipps] UPDATE_VIPPS_CONNECTION_RESPONSE',
    OpenVippsForm = '[settings/paymentConnections/vipps] OPEN_VIPPS_FORM',
    CloseVippsModal = '[settings/paymentConnections/vipps] CLOSE_VIPPS_MODAL',
    VippsApiError = '[settings/paymentConnections/vipps] VIPPS_API_ERROR',
}

export interface OpenVippsModal {
    type: ActionTypes.OpenVippsModal;
    payload: {
        accountId: string;
        account: Account;
    };
}

export function openVippsModal(accountId: string, account: Account): OpenVippsModal {
    return {
        type: ActionTypes.OpenVippsModal,
        payload: { accountId, account },
    };
}

export interface OpenVippsForm {
    type: ActionTypes.OpenVippsForm;
    payload: {};
}

export function openVippsForm(): OpenVippsForm {
    return {
        type: ActionTypes.OpenVippsForm,
        payload: {},
    };
}

export interface CloseVippsModal {
    type: ActionTypes.CloseVippsModal;
    payload: {};
}

export function closeVippsModal(): CloseVippsModal {
    return {
        type: ActionTypes.CloseVippsModal,
        payload: {},
    };
}

export interface InitiateVippsConnection {
    type: ActionTypes.InitiateVippsConnection;
    payload: {
        accountId: string;
    };
}

export function initiateVippsConnection(accountId: string): InitiateVippsConnection {
    return {
        type: ActionTypes.InitiateVippsConnection,
        payload: {
            accountId,
        },
    };
}

export interface UpdateAccountAndInitiateVippsConnection {
    type: ActionTypes.UpdateAccountAndInitiateVippsConnection;
    payload: {
        accountId: string;
        account: Account;
    };
}

export function updateAccountAndInitiateVippsConnection(
    accountId: string,
    account: Account
): UpdateAccountAndInitiateVippsConnection {
    return {
        type: ActionTypes.UpdateAccountAndInitiateVippsConnection,
        payload: {
            accountId,
            account,
        },
    };
}

export interface FetchInitiateVippsConnectionResponse {
    type: ActionTypes.FetchInitiateVippsConnectionResponse;
    payload: {
        response: VippsConnection;
    };
    meta: {
        cause: InitiateVippsConnection;
    };
}

export interface UpdateVippsConnection {
    type: ActionTypes.UpdateVippsConnection;
    payload: {
        accountId: string;
    };
}

export function updateVippsConnection(accountId: string): UpdateVippsConnection {
    return {
        type: ActionTypes.UpdateVippsConnection,
        payload: {
            accountId,
        },
    };
}

export interface UpdateVippsConnectionResponse {
    type: ActionTypes.UpdateVippsConnectionResponse;
    payload: {
        response: VippsConnection;
    };
    meta: {
        cause: UpdateVippsConnection;
    };
}

export interface VippsApiError {
    type: ActionTypes.VippsApiError;
    payload: {};
}

export type Actions =
    | OpenVippsModal
    | CloseVippsModal
    | InitiateVippsConnection
    | UpdateAccountAndInitiateVippsConnection
    | FetchInitiateVippsConnectionResponse
    | OpenVippsForm
    | VippsApiError
    | UpdateVippsConnection
    | UpdateVippsConnectionResponse;
